import {ObjUtil} from 'yougile-util'
import {DataObjectId, Hub, SandboxTree, User} from 'yougile-model'
import {DepartmentsClient} from '@client/departments-client'
import {EmployeeSettings} from '@client/employee-settings'
import {TableUserInfo} from '@components/common/base/users-table/types'
import {UserProxy} from '@extensions/proxies/user-proxy'
import {UserAccess} from '@extensions/user-access'

export class UsersTableUtil {
  static convertUserProxy(
    box: SandboxTree,
    proxy: UserProxy,
    proj?: Hub
  ): TableUserInfo {
    const role = UserAccess.getRoleInProject(proxy.userId, proj)
    const roleTitle = role
      ? UserAccess.getRoleTitle(role, Object.values(proj?.data?.roles ?? {}))
      : undefined
    return {
      id: proxy.userId,
      userId: proxy.userId,
      userName: proxy.userName,
      position: EmployeeSettings.getPosition(proxy.userId),
      departments: DepartmentsClient.listForUser(box, proxy.userId)
        .map(x => x.title)
        .join(', '),
      email: proxy.userEmail,
      avatar: proxy.userImage,
      role: roleTitle
    }
  }

  static convertUser(box: SandboxTree, user: User, proj?: Hub): TableUserInfo {
    return this.convertUserProxy(box, UserProxy.create(user), proj)
  }

  static allSelected(
    userId: DataObjectId,
    tasksOnUser: {
      [key: DataObjectId]: 'all' | 'some' | 'none'
    }
  ): boolean | undefined {
    if (!tasksOnUser) {
      return false
    }

    const t = tasksOnUser[userId]

    if (t === 'none') {
      return false
    }
    if (t === 'all') {
      return true
    }
    return undefined
  }

  static allSelectedValue(
    allSelected: boolean | undefined,
    tasksOnUser: {
      [key: DataObjectId]: 'all' | 'some' | 'none'
    }
  ): boolean | undefined {
    for (const value of ObjUtil.values(tasksOnUser)) {
      if (value === 'some') {
        return undefined
      }
    }
    return allSelected
  }
}
